import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _ReactiveState___init__impl__fvdp9b(raw) {
  return raw;
}
function _ReactiveState___get_raw__impl__92ipya($this) {
  return $this;
}
function ReactiveState__get_impl_reoidr($this) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya($this);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    throw NotReadyException().new_com_lightningkite_reactive_core_NotReadyException_trc2v8_k$();
  } else {
    if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
      throw NotActiveException().new_com_lightningkite_reactive_core_NotActiveException_krnzpk_k$();
    } else {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        throw _ReactiveState___get_raw__impl__92ipya($this).exception_1;
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          tmp = _ReactiveState___get_raw__impl__92ipya($this).other_1;
        } else {
          tmp = _ReactiveState___get_raw__impl__92ipya($this);
        }
      }
    }
  }
  return tmp;
}
function ReactiveState__getOrNull_impl_1asnfp($this) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya($this);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    tmp = null;
  } else {
    if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
      tmp = null;
    } else {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        _ReactiveState___get_raw__impl__92ipya($this).exception_1;
        tmp = null;
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          tmp = _ReactiveState___get_raw__impl__92ipya($this).other_1;
        } else {
          tmp = _ReactiveState___get_raw__impl__92ipya($this);
        }
      }
    }
  }
  return tmp;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = _ReactiveState___init__impl__fvdp9b(InternalReactiveNotReady_instance);
        tmp.notReady_1 = new (ReactiveState())(tmp_0) instanceof ReactiveState() ? tmp_0 : THROW_CCE();
        var tmp_1 = this;
        var tmp_2 = _ReactiveState___init__impl__fvdp9b(InternalReactiveNotActive_instance);
        tmp_1.notActive_1 = new (ReactiveState())(tmp_2) instanceof ReactiveState() ? tmp_2 : THROW_CCE();
      }
      exception_iibuh2_k$(exception) {
        var tmp;
        if (exception instanceof CancellationException()) {
          tmp = this.notReady_1;
        } else {
          tmp = _ReactiveState___init__impl__fvdp9b(new (InternalReactiveThrownException())(exception));
        }
        var tmp_0 = tmp;
        return new (ReactiveState())(tmp_0) instanceof ReactiveState() ? tmp_0 : THROW_CCE();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function ReactiveState__toString_impl_65vhu1($this) {
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya($this);
  var tmp;
  if (tmp0_subject instanceof InternalReactiveNotReady()) {
    tmp = 'NotReady';
  } else {
    if (tmp0_subject instanceof InternalReactiveNotActive()) {
      tmp = 'NotActive';
    } else {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        tmp = 'ThrownException(' + _ReactiveState___get_raw__impl__92ipya($this).exception_1.toString() + ')';
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          tmp = 'ReadyW(' + toString(_ReactiveState___get_raw__impl__92ipya($this)) + ')';
        } else {
          tmp = 'Ready(' + toString_0(_ReactiveState___get_raw__impl__92ipya($this)) + ')';
        }
      }
    }
  }
  return tmp;
}
function ReactiveState__hashCode_impl_flaeyu($this) {
  return $this == null ? 0 : hashCode($this);
}
function ReactiveState__equals_impl_lyar8q($this, other) {
  if (!(other instanceof ReactiveState()))
    return false;
  var tmp0_other_with_cast = other.raw_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ReactiveStateClass;
function ReactiveState() {
  if (ReactiveStateClass === VOID) {
    class $ {
      constructor(raw) {
        Companion_getInstance();
        this.raw_1 = raw;
      }
      toString() {
        return ReactiveState__toString_impl_65vhu1(this.raw_1);
      }
      hashCode() {
        return ReactiveState__hashCode_impl_flaeyu(this.raw_1);
      }
      equals(other) {
        return ReactiveState__equals_impl_lyar8q(this.raw_1, other);
      }
    }
    initMetadataForClass($, 'ReactiveState');
    ReactiveStateClass = $;
  }
  return ReactiveStateClass;
}
var InternalReactiveNotReadyClass;
function InternalReactiveNotReady() {
  if (InternalReactiveNotReadyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'InternalReactiveNotReady');
    InternalReactiveNotReadyClass = $;
  }
  return InternalReactiveNotReadyClass;
}
var InternalReactiveNotReady_instance;
function InternalReactiveNotReady_getInstance() {
  return InternalReactiveNotReady_instance;
}
var InternalReactiveNotActiveClass;
function InternalReactiveNotActive() {
  if (InternalReactiveNotActiveClass === VOID) {
    class $ {}
    initMetadataForObject($, 'InternalReactiveNotActive');
    InternalReactiveNotActiveClass = $;
  }
  return InternalReactiveNotActiveClass;
}
var InternalReactiveNotActive_instance;
function InternalReactiveNotActive_getInstance() {
  return InternalReactiveNotActive_instance;
}
var InternalReactiveThrownExceptionClass;
function InternalReactiveThrownException() {
  if (InternalReactiveThrownExceptionClass === VOID) {
    class $ {
      constructor(exception) {
        this.exception_1 = exception;
      }
      toString() {
        return 'InternalReactiveThrownException(exception=' + this.exception_1.toString() + ')';
      }
      hashCode() {
        return hashCode(this.exception_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof InternalReactiveThrownException()))
          return false;
        if (!equals(this.exception_1, other.exception_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'InternalReactiveThrownException');
    InternalReactiveThrownExceptionClass = $;
  }
  return InternalReactiveThrownExceptionClass;
}
var InternalReactiveWrapperClass;
function InternalReactiveWrapper() {
  if (InternalReactiveWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'InternalReactiveWrapper');
    InternalReactiveWrapperClass = $;
  }
  return InternalReactiveWrapperClass;
}
var NotReadyExceptionClass;
function NotReadyException() {
  if (NotReadyExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(message) {
        return new.target.new_com_lightningkite_reactive_core_NotReadyException_trc2v8_k$(message);
      }
      static new_com_lightningkite_reactive_core_NotReadyException_trc2v8_k$(message) {
        message = message === VOID ? null : message;
        var $this = this.new_kotlin_IllegalStateException_w47ei6_k$(message);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'NotReadyException', $.new_com_lightningkite_reactive_core_NotReadyException_trc2v8_k$);
    NotReadyExceptionClass = $;
  }
  return NotReadyExceptionClass;
}
var NotActiveExceptionClass;
function NotActiveException() {
  if (NotActiveExceptionClass === VOID) {
    class $ extends NotReadyException() {
      constructor(message) {
        return new.target.new_com_lightningkite_reactive_core_NotActiveException_krnzpk_k$(message);
      }
      static new_com_lightningkite_reactive_core_NotActiveException_krnzpk_k$(message) {
        message = message === VOID ? 'Nothing is listening to this reactive value, so it has no value to report. Subscribe to it, or use awaitOnce.' : message;
        var $this = this.new_com_lightningkite_reactive_core_NotReadyException_trc2v8_k$(message);
        captureStack($this, $this.$throwableCtor_5);
        return $this;
      }
    }
    initMetadataForClass($, 'NotActiveException', $.new_com_lightningkite_reactive_core_NotActiveException_krnzpk_k$);
    NotActiveExceptionClass = $;
  }
  return NotActiveExceptionClass;
}
//region block: init
InternalReactiveNotReady_instance = new (InternalReactiveNotReady())();
InternalReactiveNotActive_instance = new (InternalReactiveNotActive())();
//endregion
//region block: exports
export {
  InternalReactiveNotActive as InternalReactiveNotActive2613wuivyis0b,
  InternalReactiveNotReady as InternalReactiveNotReadygki7zhqkkp9u,
  InternalReactiveThrownException as InternalReactiveThrownException1wn4fe03qbefg,
  InternalReactiveWrapper as InternalReactiveWrapper6qytbrc1rcqv,
  ReactiveState as ReactiveStatel8ixobo86msn,
  _ReactiveState___init__impl__fvdp9b as _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m,
  ReactiveState__getOrNull_impl_1asnfp as ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq,
  ReactiveState__get_impl_reoidr as ReactiveState__get_impl_reoidrydwo1sb45wj0,
  _ReactiveState___get_raw__impl__92ipya as _ReactiveState___get_raw__impl__92ipya3q1gard26whe6,
  ReactiveState__toString_impl_65vhu1 as ReactiveState__toString_impl_65vhu13kawcnu6lmh9s,
  InternalReactiveNotActive_instance as InternalReactiveNotActive_instanceavp2nits8goa,
  InternalReactiveNotReady_instance as InternalReactiveNotReady_instancer79hznuwejmn,
  Companion_getInstance as Companion_getInstance3byfqsk8b0ql6,
};
//endregion

//# sourceMappingURL=ReactiveState.mjs.map
